<template>
  <BaseChart
    :chart-data="chartData"
    :chart-options="getChartOptions"
  />
</template>

<script>
import BaseChart from './BaseChart.vue';

export default {
  name: 'BarChart',
  components: { BaseChart },
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  computed: {
    getChartOptions () {
      return {
        axisX: {
          titleFontSize: 19,
          labelFontColor: 'black',
          labelFontWeight: 'bold'
        },
        data: [{
          type: 'column',
          toolTipContent: '{label}: {y}',
          dataPoints: this.chartData.values?.map(item => ({
            y: item.count,
            label: item.name,
            color: item.color,
            click: () => this.handleClick(item.to)
          })) || []
        }]
      };
    }
  },
  methods: {
    handleClick (to) {
      if (to) {
        this.$router.push(to);
      }
    }
  }
};
</script>
